module.exports = __webpack_public_path__ + "static/media/logo_hor.6f119b94.svg";